/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SmsConfiguration } from '../models/SmsConfiguration';
import type { SmsConfigurationProjection } from '../models/SmsConfigurationProjection';
import type { UpdateSmsProviderKeyRequest } from '../models/UpdateSmsProviderKeyRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class SmsConfigurationRestControllerService {
  /**
   * getSmsProviders
   * @returns SmsConfigurationProjection OK
   * @throws ApiError
   */
  public static getSmsProvidersUsingGet({
    xTenantId,
  }: {
    /**
     * X-TENANT-ID
     */
    xTenantId: string;
  }): CancelablePromise<Array<SmsConfigurationProjection>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/sms-configuration',
      headers: {
        'X-TENANT-ID': xTenantId,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * activateSmsProvider
   * @returns SmsConfiguration OK
   * @returns any Created
   * @throws ApiError
   */
  public static activateSmsProviderUsingPut({
    id,
    xTenantId,
  }: {
    /**
     * id
     */
    id: string;
    /**
     * X-TENANT-ID
     */
    xTenantId: string;
  }): CancelablePromise<SmsConfiguration | any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/sms-configuration/activate/{id}',
      path: {
        id: id,
      },
      headers: {
        'X-TENANT-ID': xTenantId,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * updateSmsProviderKeys
   * @returns SmsConfiguration OK
   * @returns any Created
   * @throws ApiError
   */
  public static updateSmsProviderKeysUsingPost({
    request,
  }: {
    /**
     * request
     */
    request: UpdateSmsProviderKeyRequest;
  }): CancelablePromise<SmsConfiguration | any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/sms-configuration/keys',
      body: request,
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }
}
